import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { SecurityService } from "./service/security.service";
import { Router } from "@angular/router";

export const InterceptorSkipContentTypeHeader = 'skip-content-type-header';

@Injectable()
export class SecurityHeaderInterceptor implements HttpInterceptor {
  constructor(
    private securityService: SecurityService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = new HttpHeaders();
    request.headers.keys().forEach((key) => {
      if (key.toLowerCase() !== "cookie" && key !== InterceptorSkipContentTypeHeader) {
        headers = headers.append(key, request.headers.get(key) || "");
      }
    });

    let req = request.clone({
      setHeaders: {
        ServiceId: this.securityService.getServiceId(),
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + this.securityService.getToken(),
      },
      headers: headers,
    });
    if(request.headers.has(InterceptorSkipContentTypeHeader)){
      req = request.clone({
        setHeaders: {
          ServiceId: this.securityService.getServiceId(),
          Accept: "application/json",
          Authorization: "Bearer " + this.securityService.getToken(),
        },
        headers: headers,
      });
    } 
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          window.location.reload();
          this.securityService.signOut();
          this.router.navigate(["/", "logout"]);
        }
        return throwError(() => error);
      })
    );
  }
}
